import { Validator } from "../../../TOOLS/Validator";
import { InventoryHeader } from "./InventoryHeader";
import { FormController } from "./FormController";
export class InventoryForm {

    constructor(store) {
        this.store = store;
        this.validator = new Validator(this.store);
        this.formController = new FormController(this.store, this.validator)
        this.container = document.createElement("div");
        this.container.className = 'width-100 height-100';
        this.container.id = 'INVENTORYFORM MAIN';
        this.formObject = this.store.level.selectedDevice ?? {category: "", firestoreid: "", imei: "", brand: "", userid: null, leltar: "2026", barcode: "", id: 0, officeid: 0, ws: "", sn: "", type: "", model: "", comment: ""}
        this.header = new InventoryHeader(this.store, this.formObject);
        this.excludedFields = [];
        this.keyChange = {
            category: "Kategória",
            brand: "Megnevezés",
            barcode: "Vonalkód",
            sn: "Szériaszám",
            model: "típus",
            comment: "Megjegyzés",
            userid: "kolléga"
        };
        this.officeRolldown = [];
        this.categoryRolldown = [];
        this.brandRolldown = [];
        this.categorySelect = null;
        this.brandSelect = null;
        this.selectedOffice = null;
        this.log = null;
    }

    async render() {
        this.username = await this.store.datas.findOne('USERS', 'id', this.formObject.userid)
        //FORMMEZŐK KIZÁRÁSA
        if (this.store.level.formType === "IT") {this.excludedFields = ["id", "firestoreid", "districtid", "officeid", "leltar", "type"];
        } else {this.excludedFields = ["id", "firestoreid", "districtid", "userid", "leltar", "type"];}
        
        if(this.store.level.formType === "FURNITURE"){
            let cities = await this.store.datas.filter('CITIES', 'district', this.store.level.selectedOffice);
            await this.buildRolldowns(cities)
        }else{await this.buildRolldowns()}
        this.container.innerHTML = "";
        const wrapper = document.createElement("div");
        wrapper.className = "wrapper width-100 height-100 column";
        wrapper.id = 'INVENTORYFORM WRAPPER'
        wrapper.appendChild(this.header.render());

         // Az űrlap külön konténerbe kerül
        this.formContainer = document.createElement("div");
        this.formContainer.className = "sectionColumn";
        this.formContainer.id = 'FORMSECTION'
        this.formContainer.appendChild(this.renderForm());
        wrapper.appendChild(this.formContainer);
        
        this.container.appendChild(wrapper);

        // A fejléc jelezheti, ha a lognézetet meg kell nyitni
        this.header.onShowLogs = () => {this.formContainer.style.display = "none";};
        this.header.onHideLogs = () => {this.formContainer.style.display = "";};
        return this.container;

    }

renderForm() {
        const form = document.createElement("form");
        form.id = "FORMWRAPPER";
        form.className = "width-100 height-100 column align-center overflow-y";
        
        Object.entries(this.formObject)
        
        .filter(([key]) => {
            if (this.excludedFields.includes(key)) {return false;}
            if (this.store.level.formType === "FURNITURE" && key === "category") return false;
            return true;
        })
        .forEach(([key, value]) => {
            const row = document.createElement("div");
            row.className = "list-row";
            const label = document.createElement("label");
            label.textContent = this.keyChange[key] ?? key;
            row.appendChild(label);
            let field;
            if (key === "category" && this.store.level.formType === "IT") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                this.categoryRolldown.forEach(item => {
                    const option = document.createElement("option");
                    option.value = item.value;
                    option.textContent = item.value;
                    if (item.value === value) option.selected = true;
                    field.appendChild(option);
                });
                this.categorySelect = field;
            } else if (key === "brand") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                this.brandSelect = field;
                this.brandRolldown.forEach(item => {
                    const option = document.createElement("option");
                    option.value = item.value;
                    option.textContent = item.value;
                    if (item.value === value) option.selected = true;
                    field.appendChild(option);
                });
            } else if (key === "officeid") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                field.addEventListener("change", () => {this.selectedOffice = field.value ? Number(field.value) : this.store.level.selectedDevice.officeid;});
                 this.selectedOffice = value != null ? Number(value) : Number(this.store.level.selectedDevice.officeid);
                this.officeRolldown.forEach(office => {
                    const option = document.createElement("option");
                    option.className = 'form-input'
                    option.value = office.officeid;
                    option.textContent = office.name;
                     if (parseInt(office.officeid) === value) {
                        option.selected = true;
                        this.selectedOffice = parseInt(office.officeid);
                    }
                    field.appendChild(option);
                });
            } else if (key === "userid") {
                field = document.createElement("div");
                field.className = 'form-input'
                field.textContent = this.username.name
            }else {
                field = document.createElement("input");
                field.className = 'form-input'
                field.name = key;
                field.type = typeof value === "number" ? "number" : "text";
                field.value = value ?? "";
            }
            row.appendChild(field);
            form.appendChild(row);
        });

        if (this.categorySelect && this.brandSelect) {
                this.categorySelect.addEventListener("change", () => {this.updateBrandDropdown(this.categorySelect.value, this.brandSelect, this.formObject.brand);});
                // ha már van kiválasztott kategória
                if (this.categorySelect.value && this.categorySelect.value !== "válassz!") {this.updateBrandDropdown(this.categorySelect.value, this.brandSelect, this.formObject.brand);}
            }
        const button = document.createElement("div");
        button.className = 'width-100 height-20 justify-center margin-top-2 login-button'
        button.style.flexShrink = "0";
        button.type = "submit";
        form.appendChild(button);
         this.bindItemEvents(button, form);
        return form
    }

    bindItemEvents(button, form) {
        button.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.formController.bindSubmit(form, {
                getData: this.getData.bind(this),
                complete: this.complete.bind(this),
                process: this.store.level.selectedDevice === null ? "SAVE" : "MODIFY",
                formType: 'INVENTORY',
                original: this.store.level.selectedDevice === null ? this.getData(form) : this.store.level.selectedDevice,
                actiontype: "MODIFY",
                reference: "INVENTORY",
                onSuccess: async (response) => {
                    this.store.levelController.setLevel({name: "MAP", office: null, position: null});
                    this.store.toast.success(response);
                }
            });
            form.requestSubmit();
        });
    }

    async buildRolldowns() {
        if(this.store.level.formType === "FURNITURE"){
            const furnitures = await this.store.datas.filter('INVENTORY', 'type', 'FURNITURE')
            this.brandRolldown = [...new Set(furnitures.map(item => item.model))].map(model => ({key: model, value: model}));
            this.officeRolldown = await this.store.datas.getOfficeRolldownByDistrict(this.store.level.selectedDistrict)
         }else if(this.store.level.formType === "IT"){
            const devices = await this.store.datas.filter('INVENTORY', 'type', 'IT')
            this.categoryRolldown = [...new Set(devices.map(item => item.category))].map(category => ({key: category, value: category}));
        }
    }

    getData(form) {
        const result = { ...this.formObject };
        Array.from(form.elements).forEach(element => {
        if (!element.name) return;
        if (element.name === "job") {result.job = element.checked ? "HO" : "FG";
        } else if (element.name === "officeid") {result.officeid = Number(element.value);
        } else {result[element.name] = element.type === "number" ? Number(element.value) : element.value;}
    });
        return result;
    }


    async complete(data) {
        if(this.store.level.selectedDevice.category === data.category){data.brand = this.store.level.selectedDevice.brand}
        return data    
    }

    async updateBrandDropdown(category, brandSelect, currentBrand = null) {
        brandSelect.innerHTML = "";
        const loadInventory = await this.store.datas.load('INVENTORY');
        const brands = [...new Set(this.store.database.inventory.filter(item => item.category === category).map(item => item.brand))];
        const first = document.createElement("option");
        first.value = "";
        first.textContent = currentBrand || "válassz!";;
        brandSelect.appendChild(first);
        brands.forEach(brand => {
            const option = document.createElement("option");
            option.value = brand;
            option.textContent = brand;
            if (brand === currentBrand) {option.selected = true;}
            brandSelect.appendChild(option);
        });
    }

    destroy() {this.formController.destroy();}

}